import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const TABLE_IS_SCROLL_CS = "is-scrolling";

export const StyledScrollableTableContent = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit;
`;

export const StyledExpandedRowContent = styled.section<{ $minHeight: number }>`
    min-height: ${({ $minHeight }) => `${$minHeight}px`};
    overflow: auto;

    & .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }

    & .ant-table-wrapper .ant-table-pagination.ant-pagination {
        padding-bottom: 6px;
        border-top: 1px solid ${colorsPalettes.carbon[50]};
    }
`;